module.exports = __webpack_public_path__ + "static/media/IMG_1520.feaf6fa0.jpg";